module.exports = __webpack_public_path__ + "img/HENSEX LOGO (1).18530852.png";